<template>
  <section id="staffIndex">
    <HeaderBackground :backgroundPath="`/${$staticPath}/${index.backgroundPath}`"></HeaderBackground>
    <Staff></Staff>
  </section>
</template>

<script>
import HeaderBackground from '../COMMON/HeaderBackground'
import Staff from './Staff.vue'

export default {
  components: {
    HeaderBackground,
    Staff
  },
  data () {
    return {
      index: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var index = await import('../../json/en/staff/index.json')
      } else {
        index = await import('../../json/th/staff/index.json')
      }
      this.index = index
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/STAFF/Index.vue